import { is } from 'stdlib/is'

/**
 * Termékek lekérdezéséhez szűrési feltételek összeállítása.
 * @param categoryName - A megadott kategória neve.
 */
export default function getProductFilterQueries (categoryName: string | undefined): TReadonlyRecord<string, string> {
  const selectedCategory = is.undefined(categoryName)
    ? document.body.querySelector<HTMLInputElement>('input[name="category-name"]:checked')?.value ?? 'all'
    : categoryName

  const pieceFilter = document.body.querySelector<HTMLInputElement>('input[name="pieces"]:checked')?.value ?? ''

  const [ minPiece = '', maxPiece = '' ] = pieceFilter.split('-')

  const priceFilter = document.body.querySelector<HTMLInputElement>('input[name="prices"]:checked')?.value ?? ''

  const [ minPrice = '', maxPrice = '' ] = priceFilter.split('-')

  const search = document.body.querySelector<HTMLInputElement>(
    'input.categories-section__search-input'
  )?.value

  return {
    categoryName: selectedCategory,
    ...(minPiece && is.numeric(minPiece) ? { minPiece } : {}),
    ...(maxPiece && is.numeric(maxPiece) ? { maxPiece } : {}),
    ...(minPrice && is.numeric(minPrice) ? { minPrice } : {}),
    ...(maxPrice && is.numeric(maxPrice) ? { maxPrice } : {}),
    ...(search && !is.empty(search) ? { search } : {})
  }
}
